class CareChooseDialog extends HTMLElement {
    isOpen = false;
    chooseId = '';
  
    constructor() {
      super();
      this.init();
    }
  
    init() {
      try {
        this.productTitle = this.dataset.productTitle;
        this.careList = this.dataset.cares ? JSON.parse(this.dataset.cares) : [];
      } catch (error) {
        console.error('初始化错误', error);
      }


      const closeBtn = this.querySelector('#close-modal-btn');
      closeBtn.addEventListener('click', () => {
        this.closeModal();
        this.barAddCart();
        dataLayer.push({
          event: 'care-dialog-skip',
          timestamp: new Date().toISOString(),
        });
      });

      const addCartBtn = this.querySelector('.add-cart-btn');
      addCartBtn.addEventListener('click', () => {
        // 调用购物车添加商品
        this.chooseId = ''
        this.handleAddToCart();
        this.closeModal();
        dataLayer.push({
          event: 'care-dialog-add-cart',
          timestamp: new Date().toISOString(),
        });
      });

      const skipBtn = this.querySelector('.skip-btn');
      skipBtn.addEventListener('click', () => {
        this.closeModal();
        this.barAddCart();
        dataLayer.push({
          event: 'care-dialog-skip',
          timestamp: new Date().toISOString(),
        });
      });
      // const mask = document.getElementById('hovercare-choose-modalMask');
      // mask.addEventListener('click', closeModal);

    }
    updateSelectProduct() {
      // 找到被选中的Flying Camera
      const normal = Array.from(
        document.querySelectorAll('.product-normal-option')
      ).find((item) => {
        const input = item.querySelector('input');
        return input && input.checked;
      });
      if (!normal) return;
      this.chooseId = '';
      const variantName = normal.dataset.variantName;
      if (variantName) {
        
        const careProductTags = Array.from(
          this.querySelectorAll('.care-product-container')
        );
        careProductTags.forEach((tag, index) => {
          // care 匹配到matchName 或者变体名称 显示
          if (tag.dataset.matchName == this.productTitle || tag.dataset.matchName == variantName) {
            tag.classList.remove('tw-hidden');
            tag.classList.add('current-care-product');
          } else {
            tag.classList.add('tw-hidden');
            tag.classList.remove('current-care-product');
            
          }
        });
      }
      
    }
    handleAddToCart() {
      // 找到当前显示的 care-product-container
      const currentCareProduct = this.querySelector('.current-care-product');
      
      if (currentCareProduct) {
        // 在当前显示的 care-product-container 内查找 input[name="version-radio-option"]
        const versionRadios = currentCareProduct.querySelectorAll(
          '.variant-radio-group input[type="radio"]'
        );
        
        // 处理找到的 radio 按钮
        versionRadios.forEach(radio => {
          if (radio.checked) {
            // 处理选中的 radio 按钮
            this.chooseId = radio.value;
          }
        });
      } 
    
      this.barAddCart();
    }
    barAddCart() {
       // 更新购买栏价格
      const bar = document.querySelector('buy-bottom-bar');
      if (bar) {
        bar.handleAddToCart();
      }
    }
    showModal() {
      console.log('showModal ----- ')
      const modal = this.querySelector('#hovercare-choosemodal');
      const mask = this.querySelector('#hovercare-choose-modalMask');
      const body = document.body;
      modal.style.display = 'block';
      mask.style.display = 'block';
      setTimeout(() => {
        modal.classList.add('show');
      }, 10);
      body.classList.add('modal-open');
      window.zzLockBodyScroll && window.zzLockBodyScroll();
      dataLayer.push({
        event: 'care-dialog-open',
        timestamp: new Date().toISOString(),
      });
    }
    closeModal() {
      this.chooseId = '';
      const modal = this.querySelector('#hovercare-choosemodal');
      const mask = this.querySelector('#hovercare-choose-modalMask');
      const body = document.body;
      modal.classList.remove('show');
      window.zzUnlockBodyScroll && window.zzUnlockBodyScroll();
      setTimeout(() => {
        modal.style.display = 'none';
        mask.style.display = 'none';
      }, 300);
      body.classList.remove('modal-open');
    }
   
  
  
  }
  

customElements.define('product-detail-dialog-hovercare-choose', CareChooseDialog);

  